const doc = [({"en":({"platformId":"Platform ID", "name":"Name", "subject":"Subject", "text":"Text"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;